module.exports = __webpack_public_path__ + "img/horizontal_4_7_pp23_9006.27d6a0b9.png";